<!-- 交易号平台支付比对列表 -->
<template>
  <div>
    <div class="opage">
      <!-- 资金/交易号平台支付比对列表 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.purchasePayCheckList')"></baseBreadcrumb>
      <div class="tab">
        <tableTab :val.sync="form.deal_status" :list="[
          // 待处理
          { name: this.$t('message.toBeProcessed'), value: '0' },
          // 已处理
          { name: this.$t('message.processed'), value: '1' },
        ]
          " :fun="getData">
        </tableTab>
        <!-- 操作 -->
        <div class="operation">
          <el-select v-model="compare_type" placeholder="请选择平台" @change="linkChange" style="margin-right: 20px;">
            <el-option label="日本站" value="1">
            </el-option>
            <el-option label="西班牙财务" value="eu">
            </el-option>
            <el-option label="OEM财务" value="oem">
            </el-option>
            <el-option label="俄罗斯财务" value="ru">
            </el-option>
            <el-option label="美国财务" value="us">
            </el-option>
            <el-option label="日本小件" value="2c">
            </el-option>
            <el-option label="意大利财务" value="it">
            </el-option>
          </el-select>
          <!-- 批量生成支付链接 -->
          <el-button type="primary" class="primary" @click="orderNewPay('')" v-if="isAuth(708)">PINGPONG支付</el-button>
          <!-- 批量生成支付链接 -->
          <el-button type="primary" class="primary" @click="orderNewPay('creditPay')"
            v-if="isAuth(708)">诚e赊支付</el-button>
          <!-- 批量生成支付链接 -->
          <el-button type="primary" class="primary" @click="orderNewPay('alipay')" v-if="isAuth(708)">支付宝支付</el-button>
          <!-- 批量生成支付链接 -->
          <el-button type="primary" class="primary" @click="orderNewPay('')" v-if="isAuth(708)">{{
            $t("message.generatePaymentLinks")
          }}</el-button>
          <!-- 标记处理 -->
          <el-button type="primary" class="primary" @click="purchasePayCheckDeal">{{
            $t("message.markProcessed")
          }}</el-button>
        </div>
      </div>

      <div class="searchBox">
        <!-- 客户ID -->
        <el-input size="small" :placeholder="$t('message.clientID')" v-model="form.user_id" clearable></el-input>
        <!-- 客户姓名 -->
        <el-input size="small" :placeholder="$t('message.clientName')" v-model="form.realname" clearable></el-input>
        <!-- 交易号 -->
        <el-input size="small" :placeholder="$t('message.transactionNumber')" v-model="form.purchase_no"
          clearable></el-input>
        <!-- 订单号 -->
        <el-input size="small" :placeholder="$t('message.orderNumber')" v-model="form.order_sn" clearable></el-input>
        <!-- 来源平台 -->
        <el-select size="small" :placeholder="$t('message.fromPlatform')" v-model="form.from_platform" clearable>
          <el-option label="1688" value="1688">
          </el-option>
          <el-option label="taobao" value="taobao">
          </el-option>
          <el-option label="163" value="163">
          </el-option>
          <el-option label="88生意通" value="88生意通">
          </el-option>
        </el-select>
        <!-- 平台支付状态 -->
        <el-select size="small" v-model="form.platform_is_paid" :placeholder="$t('message.platformPaymentStatus')"
          clearable>
          <el-option label="未查到" value="0">
          </el-option>
          <el-option label="已支付" value="1">
          </el-option>
          <el-option label="未支付" value="2">
          </el-option>
        </el-select>
        <!-- 金额匹配状态 -->
        <el-select size="small" v-model="form.amount_matched" :placeholder="$t('message.amountMatchStatus')" clearable>
          <el-option label="不匹配" value="0">
          </el-option>
          <el-option label="匹配" value="1">
          </el-option>
        </el-select>
        <!-- 是否可支付 -->
        <el-select size="small" v-model="form.buyerRemarkIcon" :placeholder="$t('message.isPayable')" clearable>
          <el-option label="可支付" value="3">
          </el-option>
          <el-option label="不可支付" value="1">
          </el-option>
        </el-select>
        <!-- 是否支持跨境宝 -->
        <el-select size="small" v-model="form.pay_flag" placeholder="是否支持跨境宝" clearable>
          <el-option label="支持跨境宝" value="1">
          </el-option>
          <el-option label="仅支持支付宝" value="2">
          </el-option>
          <el-option label="支持诚e赊" value="3">
          </el-option>
          <el-option label="支持PINGPONG" value="4">
          </el-option>
        </el-select>
        <!-- 购买者 -->
        <el-select v-model="form.account_name" clearable filterable :placeholder="$t('message.buyAccount')"
          size="small">
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.realname">
          </el-option>
        </el-select>
        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="getData">{{
            $t("message.filter")
          }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small" @click="chongZhi">{{
            $t("message.reset")
                        }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
          'text-align': 'center',
          background: '#f8f8f8',
        }" size="mini" @selection-change="handleSelectionChange" :max-height="tableautoheight">
          <el-table-column property="rowNumber" width="50" label="No"></el-table-column>
          <el-table-column type="selection" width="45" align="center">
          </el-table-column>
          <!-- 创建时间 -->
          <el-table-column property="created_at" :label="$t('message.createTime')" width="76"></el-table-column>
          <!-- 最后更新时间 -->
          <el-table-column property="updated_at" :label="$t('message.updateTime')" width="76"></el-table-column>
          <!-- 来源平台 -->
          <el-table-column property="from_platform" :label="$t('message.fromPlatform')">
            <template slot-scope="scope">
              {{ scope.row.from_platform }}
              <p v-if="scope.row.from_platform != 'taobao'">
                <el-tag :type="scope.row.duoduo_order.buyerRemarkIcon == 3 ? 'success' : 'info'" size="mini"
                  :class="{ 'bgcRed': scope.row.duoduo_order.buyerRemarkIcon == 2, 'bgcYellow': scope.row.duoduo_order.buyerRemarkIcon == 4, 'bgcBlue': scope.row.duoduo_order.buyerRemarkIcon == 1 }">
                  {{ scope.row.duoduo_order.buyerRemarkIcon == 3 ? '可支付' :
                    '不可支付' }}</el-tag>
              </p>
              <p v-else>
                <el-tag :type="scope.row.taobao_sign_pay == 1 ? 'success' : 'info'" size="mini">
                  {{ scope.row.taobao_sign_pay == 1 ? '可支付' :
                    '不可支付' }}</el-tag>
              </p>
              <!-- 各种支付方式 -->
              <p v-for="(item, index) in scope.row.channels" :key="index"
                v-show="[1, 3, 20, 35].includes(item.code - 0)" style="margin-top: 5px;">
                <el-tag type="success" size="mini">支持{{ item.name == '网商银行跨境直采' ? 'PINGPONG' : item.name }}</el-tag>
              </p>
            </template>
          </el-table-column>
          <!-- 交易号 -->
          <el-table-column property="purchase_no" :label="$t('message.transactionNumber')"
            width="120"></el-table-column>
          <!-- 订单号 -->
          <el-table-column property="order_sn" :label="$t('message.orderNumber')" width="130">
            <template slot-scope="scope">
              <router-link :to="`/orderPaymentDetail?order_sn=${scope.row.order_sn}`" target="_blank" class="a-link">
                {{ scope.row.order_sn }}
              </router-link>
              <p>{{ scope.row.client_realname }}</p>
            </template>
          </el-table-column>
          <!-- 番号 -->
          <el-table-column :label="$t('message.mash')">
            <template slot-scope="scope">
              {{ scope.row.sorting }}
            </template>
          </el-table-column>
          <!-- 购买账户 -->
          <el-table-column :label="$t('message.buyAccount')">
            <template slot-scope="scope">
              {{ scope.row.g_realname }}
            </template>
          </el-table-column>
          <!-- 交易号内商品数量 -->
          <el-table-column property="totalNum" :label="$t('message.totalQuantity')">
          </el-table-column>
          <!-- 客户总付款 -->
          <el-table-column property="client_amount" :label="$t('message.totalPaymentAmount')">
          </el-table-column>
          <!-- 采购填写成本 -->
          <el-table-column property="system_amount" :label="$t('message.purchaseCost')">
          </el-table-column>
          <!-- 1688应付款 -->
          <el-table-column property="platform_amount" label="1688/淘宝应付款">
          </el-table-column>
          <!-- 平台支付状态 -->
          <el-table-column property="platform_is_paid_name"
            :label="$t('message.platformPaymentStatus')"></el-table-column>
          <!-- 金额匹配状态 -->
          <el-table-column property="amount_matched_name" :label="$t('message.amountMatchStatus')">
            <template slot-scope="scope">
              <el-button :type="scope.row.amount_matched == 0 ? 'danger' : 'success'" size="small"> {{
                scope.row.amount_matched_name }}</el-button>
            </template>
          </el-table-column>
          <!-- 财务备注 -->
          <el-table-column property="remark" :label="$t('message.financialRemark')" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.is_finance_remark_edit" class="financeRemarkText"
                @dblclick.stop="editFinanceRemark(scope.row)">
                <span v-if="scope.row.finance_remark">{{ scope.row.finance_remark }}</span>
                <span v-else class="financeRemarkPlaceholder">请输入</span>
              </div>
              <el-input v-else :ref="'financeRemarkInput' + scope.row.id" class="financeRemarkInput"
                v-model="scope.row.finance_remark" placeholder="请输入" type="textarea"
                @blur="finishFinanceRemarkEdit(scope.row)"></el-input>
            </template>
          </el-table-column>
          <!-- 不匹配原因说明 -->
          <el-table-column property="mismatch_reason" :label="$t('message.unmatchedReason')"></el-table-column>
          <!-- 处理状态 -->
          <el-table-column property="deal_status_name" :label="$t('message.handleStatus')">
            <template slot-scope="scope">
              {{ scope.row.deal_status_name }}
              <p><el-button type="primary" size="mini" @click="syncByPurchaseNo(scope.row)">状态同步</el-button></p>
            </template>
          </el-table-column>
          <!-- 补充资料 -->
          <el-table-column :label="$t('message.supplementalMaterials')">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="viewSupplementalMaterials(scope.row)" class="primary"
                v-if="scope.row.supplement_at">查看</el-button>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column :label="$t('message.operation')">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="purchasePayCheckRemind(scope.row)">提醒采购</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 30, 50, 100, 200, 300]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
      <!-- 淘宝支付弹框 -->
      <el-dialog title="淘宝支付详细" :visible.sync="dialogVisible" width="680px" :close-on-click-modal="false" center>
        <div class="taobaoData">
          <p class="will_pay">可支付订单号：{{ taobaoData.will_pay_purchase_order_ids.join(',') }}</p>
          <div v-for="(item, index) in taobaoData.pay_failed_results" :key="index" class="pay_failed">
            <p>支付失败订单号：{{ item.gspOrderId }}</p>
            <p>支付失败原因：{{ item.errorMessage }}</p>
            <p>支付失败错误码：{{ item.errorCode }}</p>
          </div>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('message.ok') }}</el-button>
        </template>
      </el-dialog>
    </div>
    <!-- 指纹验证弹窗 -->
    <fingerprintVerification ref="fingerprintVerification"></fingerprintVerification>
    <!-- 补充资料弹窗 -->
    <supplementalMaterials ref="supplementalMaterials"></supplementalMaterials>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
import tableTab from "../components/tableTab.vue";
import fingerprintVerification from "../components/fingerprintVerification.vue";
import supplementalMaterials from "../components/supplementalMaterials.vue";

export default {
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 240 : 800,
      form: {
        page: 1,
        pageSize: 30,
      },
      value: [],
      total: 0,
      loading: null,
      tableData: [],
      selectedRows: [],
      dialogVisible: false, // 淘宝支付弹框是否显示
      taobaoData: {
        "will_pay_purchase_order_ids": [
        ],

        "pay_failed_results": [
        ],
        "pay_failure_purchase_order_ids": [
        ]
      },
      compare_type: '1',
    };
  },
  components: {
    myImage,
    tableTab,
    fingerprintVerification,
    supplementalMaterials,
  },
  computed: {

    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
  },
  mounted() {

    this.getData();


  },
  methods: {
    // 获取数据
    getData() {
      this.$api.financialApi
        .purchasePayCheckList(this.form)
        .then((res) => {
          // console.log("事件名", res.data.data);
          if (res.code != 0) return this.$message.error(res.msg);
          // 接下来的操作
          this.tableData = res.data.data;
          this.total = res.data.total
          this.$forceUpdate();
        });
    },
    // 确认汇款订单
    confirmMe(row) {
      // 汇款确认
      this.diaTitle = this.$t("message.confirmationOfRemittance");
      // 将需要的值填入
      this.aProductInformation = JSON.parse(JSON.stringify(row));
      this.aProductInformation.user_id = "";
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              //事件
              this.$refs.dialog.close();

            } else {
            }
          });
        },
        () => {
          // 点击取消事件
        }, [this.$t('message.save'), this.$t('message.cancel')]
      );
    },
    // 删除
    financialCancel(row) {
      this.$confirm(
        this.$t(
          "message.areYouSureToDelete"
        ),
        // 汇款回退提醒
        this.$t("message.deleteOrder"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.financialApi
            .financialCancel({ id: row.id })
            .then((res) => {

              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();

            });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getData();
    },
    // 处理选择变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    // 更新财务备注
    purchasePayCheckUpdateRemark(row) {
      this.$api.financialApi
        .purchasePayCheckUpdateRemark({
          ids: [row.id],
          finance_remark: row.finance_remark,
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);

        })
        .catch(() => { });
    },
    editFinanceRemark(row) {
      this.$set(row, '_financeRemarkCache', row.finance_remark);
      this.$set(row, 'is_finance_remark_edit', true);
      this.$nextTick(() => {
        const input = this.$refs['financeRemarkInput' + row.id];
        const target = Array.isArray(input) ? input[0] : input;
        if (target && target.focus) {
          target.focus();
        }
      });
    },
    finishFinanceRemarkEdit(row) {
      this.$set(row, 'is_finance_remark_edit', false);
      if (row.finance_remark === row._financeRemarkCache) return;
      this.purchasePayCheckUpdateRemark(row);
    },
    // 生成支付链接
    orderNewPay(type) {
      if (this.selectedRows.length == 0) return this.$message.error("请选择要生成支付链接的订单");

      this.$confirm(
        this.$t(
          "message.areYouSureToGeneratePaymentLinks"
        ),
        // 生成支付链接提醒
        this.$t("message.generatePaymentLinks"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          // 指纹验证
          // this.$refs.fingerprintVerification.openDialog()
          this.fingerprintVerifySuccess('', type)
        })
        .catch(() => { });
    },
    // 标记处理
    purchasePayCheckDeal() {
      if (this.selectedRows.length == 0) return this.$message.error("请选择要标记处理的订单");
      let datas = {
        ids: this.selectedRows.map(item => item.id)
      }
      this.$confirm(
        this.$t(
          "message.areYouSureToPurchasePayCheckDeal"
        ),
        // 标记处理提醒
        '提示',
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.financialApi
            .purchasePayCheckDeal(datas)
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();
              this.selectedRows = [];
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 交易号平台支付比对标记已处理状态同步
    syncByPurchaseNo(row) {
      this.$api.financialApi
        .syncByPurchaseNo({
          purchase_no: row.purchase_no,
        })
        .then((res) => {

          this.$message.success(res.msg);
          this.getData();
        })
        .catch(() => { });
    },
    // 指纹验证成功
    fingerprintVerifySuccess(feature, type) {
      let datas = {
        purchase_no_set: this.selectedRows.map(item => item.purchase_no),
        feature,
        type
      }

      this.$api.financialApi
        .orderNewPay(datas)
        .then((res) => {
          // 1688支付成功
          if (res.data.payUrl) {
            window.open(res.data.payUrl);
          }
          // 88生意通
          if (res.data.cashierUrl) {
            window.open(res.data.cashierUrl);
          }
          // 淘宝支付失败
          if (res.data.pay_failed_results != false && res.data.pay_failed_results != null) {
            this.taobaoData = res.data;
            this.dialogVisible = true;
          }
          // 淘宝支付成功
          if (res.data.will_pay_purchase_order_ids != null && res.data.pay_failed_results == false) {
            this.$alert(
              res.data.will_pay_purchase_order_ids.join(',') + "订单都支付成功",
              "提示",
              {
                confirmButtonText: "确定",
                type: "success",
                center: true,
              }
            );
          }
          this.getData();
          this.selectedRows = [];
        })
        .catch(() => { });
    },
    // 查看补充资料
    viewSupplementalMaterials(row) {
      this.$refs.supplementalMaterials.openDialog(row)
    },
    // 财务提醒采购补充资料
    purchasePayCheckRemind(row) {
      this.$api.financialApi
        .purchasePayCheckRemind({
          ids: [row.id],
        })
        .then((res) => {
          if (res.code != 0) return this.$message.error(res.msg);
          this.$message.success(res.msg);
        })
        .catch(() => { });
    },
    // 平台切换
    linkChange(e) {
      if (e != '1') {
        this.$api
          .getJumpToken({
            to_sys: e,
          })
          .then((res) => {
            if (e == 'eu') {
              let link = 'https://spain.rakumart.es/#/transactionPaymentCompare?token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            } else if (e == 'oem') {
              let link = 'https://manage.rakumade.com/#/transactionNumberPaymentComparison?token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            } else if (e == 'ru') {
              let link = 'https://admin.sponlax.com/#/transactionPaymentCompare?token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            } else if (e == 'us') {
              let link = 'https://us.rakumart.us/#/transactionPaymentCompare?token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            }
            else if (e == '2c') {
              let link = 'https://www.rakumart-2c.com/index.php?mod=admin&act=index&autologin_token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            } else if (e == 'it') {
              let link = 'https://admin.rakumart.it/#/transactionPaymentCompare?token=' + res.data.token
              window.open(link, JSON.stringify(res.data))
            }
          })
      }

    },

  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.routerView {
  height: 100%;
}

.opage {
  background-color: #f8f8f8;
  height: 100%;


}

.tab {
  position: relative;

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.searchBox {
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 140px;
    margin-right: 10px;
  }



  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    .el-button {
      width: 64px;
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}



.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
  padding-bottom: 10px;
}

/deep/.el-textarea__inner {
  padding: 5px !important;
  height: 100px !important;
  resize: none;
}

.financeRemarkText {
  width: 100%;
  height: 100px;
  padding: 5px !important;
  box-sizing: border-box;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  background-color: #fff;
  color: #606266;
  font-size: 12px;
  font-family: inherit;
  line-height: 1.5;
  text-align: left;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-y: auto;
  cursor: text;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
}

/deep/.financeRemarkInput {
  font-size: 12px;
}

/deep/.financeRemarkInput .el-textarea__inner {
  color: #606266;
  font-size: 12px !important;
  font-family: inherit;
  line-height: 1.5;
}

.financeRemarkText:hover {
  border-color: #C0C4CC;
}

.financeRemarkPlaceholder {
  color: #C0C4CC;
}

.bgcRed {
  background-color: #fa5058 !important;
  color: #fff !important;
}

.bgcYellow {
  background-color: #f5a623 !important;
  color: #fff !important;
}

.bgcBlue {
  background-color: #2c96e7 !important;
  color: #fff !important;
}

.taobaoData {
  padding: 20px;

  p {
    margin-bottom: 10px;
  }

  .will_pay {
    font-weight: bold;
    font-size: 16px;
  }

  .pay_failed {

    font-size: 16px;
    color: #fa5058;
  }
}

/deep/.cell {
  padding: 0 3px !important;
}
</style>
